import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const Notfound = () => {
  return (
    <Box
      sx={{
        height: "70vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgColor: "#f7f7f7",
        textAlign: "center",
        p: 3,
      }}
    >
      <Typography
        variant="h1"
        fontWeight="700"
        sx={{
          fontSize: { xs: "80px", md: "140px" },
          color: "#1976d2",
          animation: "bounce 1.5s infinite",
          "@keyframes bounce": {
            "0%, 100%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-10px)" },
          },
        }}
      >
        404
      </Typography>

      <Typography variant="h5" fontWeight="600" color="text.primary" mt={2}>
        Oops! Page Not Found 😕
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        mt={1}
        sx={{ maxWidth: "400px" }}
      >
        The page you are looking for might have been removed or is temporarily unavailable.
      </Typography>

      <Button
        variant="contained"
        size="large"
        sx={{ mt: 4, px: 4, borderRadius: 3 }}
        component={Link}
        to="/"
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default Notfound;
